import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getProceduresTypes } from '../../store/actions/procedures';
import { ToastContainer } from 'react-toastify';
import Header from '../../components/Header';
import { allNotifications } from '../../utils/toastify';
import QuickAccess from './quickAccess';

const { notifyErrorBottomRight } = allNotifications;

class Home extends Component {
  notify = message => notifyErrorBottomRight(message);

  render() {
    return (
      <Fragment>
        <Header name={`Olá ${this.props.name}`} />
        <QuickAccess />
        <ToastContainer />
      </Fragment>
    );
  }
}

Home.defaultProps = {
  name: 'Doutor(a)',
  loading: true
};

Home.propTypes = {
  name: PropTypes.string,
  codigoPrestador: PropTypes.number.isRequired,
  summaryValues: PropTypes.number.isRequired,
  loading: PropTypes.bool
};

const mapStateToProps = store => ({
  loading: store.gto.loading,
  name: store.login.user.nomeUsuario,
  codigoPrestador: store.login.user.codigo,
  summaryValues: store.gto.gtosList.length
});

export default connect(mapStateToProps, { getProceduresTypes })(Home);